import { PRODUCT_COLLECTION_DATA } from '../products/queries';

export const COLLECTION_FILTER_GET_QUERY = `
query getCollectionByHandle($handle: String!, $filters: [ProductFilter!]) {
    collection(handle: $handle) {
        id
        handle
        title
        description
        products(first: 250, filters: $filters) {
            filters {
                id
                label
                type
                values {
                    id
                    label
                    count
                    input
                }
            }
        }
    }
}`;

export const COLLECTION_GET_PRODUCTS = `
query getProductsInCollection(
    $handle: String!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $sortKey: ProductCollectionSortKeys
    $reverse: Boolean
    $filters: [ProductFilter!]
    $collectionNumber: Int = 10
) {
    collection(handle: $handle) {
        id
        title
        products(
            first: $first
            last: $last
            after: $after
            before: $before
            sortKey: $sortKey
            filters: $filters
            reverse: $reverse
        ) {
            edges {
                node {
                    ${PRODUCT_COLLECTION_DATA}
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
}`;
